import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import TelMob from '../telefon';
import Icons from '../elements/icons';

// Images
import tikTok from "../../images/icon/tiktok.svg";
const getYear = new Date().getFullYear();
class aboutSection extends Component {

	render() {
		return (
			<>

				<footer className="footer">
					{/* <div className="footer-info bg-primary">
						<div className="container">
							<div className="row align-items-center">
								<div className="col-lg-3 col-md-6 col-sm-6 mb-30">
									<div className="footer-logo">
										<img src={logo2} alt=""/> 
									</div>
								</div>
								<div className="col-lg-3 col-md-6 col-sm-6 mb-30">
									<div className="feature-container left footer-info-bx">
										<div className="icon-lg">
											<span className="icon-cell"><img src={icon3} alt=""/></span> 
										</div>
										<div className="icon-content">
											<p>2005 Stokes Isle Apt. 896, Venaville 10010, USA</p>
										</div>
									</div>
								</div>
								<div className="col-lg-3 col-md-6 col-sm-6 mb-30">
									<div className="feature-container left footer-info-bx">
										<div className="icon-lg">
											<span className="icon-cell"><img src={icon1} alt=""/></span> 
										</div>
										<div className="icon-content">
											<p>+001 123 456 790 <br/>(02) 3424 44 00</p>
										</div>
									</div>
								</div>
								<div className="col-lg-3 col-md-6 col-sm-6 mb-30">
									<div className="feature-container left footer-info-bx">
										<div className="icon-lg">
											<span className="icon-cell"><img src={icon2} alt=""/></span> 
										</div>
										<div className="icon-content">
											<p>info@yourdomain.com <br/>example@support.com</p>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div> */}
					<div className="footer-top bt0">
						<div className="container">
							<div className="row">
								<div className="col-xl-4 col-md-6">
									<div className="widget footer_widget">
										<h5 className="footer-title">MajorMob Servis</h5>
										<p className="mb-20">Svaki dolazak najaviti pozivom!</p>
										<div className="ft-content">
											<i className="fa fa-phone"><Icons name='phone' /></i>
											<span>Pozovite</span>
											<h4> <TelMob><strong>+381615796175</strong></TelMob></h4>
											<h4> <TelMob num="tel:+381641320181" ><strong>+381641320181</strong></TelMob></h4>
										</div>
									</div>
								</div>
								<div className="col-xl-4 col-md-6">
									<div className="widget widget-link-2">
										<h5 className="footer-title">Mapa sajta</h5>
										<ul>
											<li><Link to="/">Početna</Link></li>
											<li><Link to="/info">O nama</Link></li>
											<li><Link to="/otkup">Otkup</Link></li>
											<li><Link to="/servis">Servis</Link></li>
											<li><Link to="/prodaja">Prodaja</Link></li>
											<li><Link to="/Kontakt">Kontakt</Link></li>
										</ul>
									</div>
								</div>
								<div className="col-xl-4 col-md-6">
									<div className="widget widget_info">
										<h5 className="footer-title">Drustvene mreze</h5>
										<p className="mb-20">Pratite nas na sledecim drustvenim mrezama.</p>
										<ul className="list-inline social-media">
											<li><a target="_blank" href="https://www.instagram.com/major.mob" rel="noreferrer" className="btn btn-primary"><Icons name='insta' /></a></li>
											<li><a target="_blank" href="https://www.tiktok.com/@major_mob" rel="noreferrer" className="btn btn-primary"><img alt="tiktok slika" src={tikTok} className="fa-brands fa-tiktok" /></a></li>
										</ul>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className="footer-bottom">
						<div className="container">
							<div className="row">
								<div className="col-lg-6 col-md-6 col-sm-12 text-center text-md-start">
									<p className="mb-0">© MajorMob Servis, {getYear}</p>
								</div>
							</div>
						</div>
					</div>
				</footer>

			</>
		);
	}
}

export default aboutSection;